import { fg } from '@atlassian/jira-feature-gating';

const fixDisabledVotingOption = {
	get(): boolean {
		return fg('jracloud-81233-fix-disabled-voting-option');
	},
};

export default fixDisabledVotingOption;
